/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import {
	Textcontol,
	__experimentalDivider as Divider,
	__experimentalUnitControl as UnitControl,
	__experimentalNumberControl as NumberControl,
	// __experimentalFontFamilyControl as FontFamilyControl,
} from '@wordpress/components';
import { addFilter } from '@wordpress/hooks';
import { __experimentalFontFamilyControl as FontFamilyControl, useSetting } from '@wordpress/block-editor';

/**
 * External dependencies
 */

/**
 * Inner dependencies.
 */
import {
	ColorControl,
	GradientColorControl,
} from '../../../extensions/controls/color-options';
import { updateBlockStyle } from '../inline-styles';
import Accordion from '../../../components/Accordion';
import blockInfo from '../constants';
const { hookPrefix } = blockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-style`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/style`,
	( content, props ) => {
		const { attributes, setAttributes } = props;
		const { gap } = attributes;
		// const blockLevelFontFamilies = useSetting( 'typography.fontFamilies' );
		// console.log( blockLevelFontFamilies );

		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				{ /* <FontFamilyControl
					// fontFamilies={ blockLevelFontFamilies }
					value={ 'fontFamily' }
					// onChange={ () => {} }
				/> */ }
				<Accordion tabs={ [
					{
						name: 'faq-style',
						initialOpen: true,
						label: () => {
							return __( 'Faq Style' );
						},
						cb: () => {
							return <>
								<UnitControl type="number" min={ 0 } max={ 100 } step={ 1 } value={ gap } onChange={ ( val ) => {
									const data = {
										gap: val,
									};
									setAttributes( data );
									updateBlockStyle( data, props );
								} } />
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);

